import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { loadUserAnswers } from '../engine/matchEngine'
import { saveLocation } from '../engine/districtSelection'
import DistrictPicker from '../components/DistrictPicker'

export default function DistrictOnboarding() {
  const { user, userPrefs, saveUserPrefs } = useAuth()
  const navigate = useNavigate()
  const saved = loadUserAnswers()
  const confirm = async (state, districts) => {
    if (user && saveUserPrefs) await saveUserPrefs(state, districts[0]?.label || '')
    saveLocation(state, districts)
    navigate('/')
  }
  return <DistrictPicker initialState={userPrefs?.state || saved.state || ''}
    initialDistrict={userPrefs?.district || saved.district || ''}
    onConfirm={confirm} onSkip={() => navigate('/')} />
}
